export const EngagementEventTypes = {
  PAGE_VIEW: "portal2: Page View",
  LOGIN: "portal2: Login",
} as const;

export type EngagementEventType = (typeof EngagementEventTypes)[keyof typeof EngagementEventTypes];
